/*eslint-disable*/
import React from "react";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import DatePicker from "components/Wrappers/materialUIWrappers/components/DatePicker";
import { Field } from "redux-form";
import {
  Grid,
  FormControl,
  Card,
  CardContent,
  CardHeader,
  withStyles,
  Typography,
  Checkbox
} from "@material-ui/core";
import store from "store";
import { change } from "redux-form";

const required = value => (value ? undefined : "Required");

const number = value => {
  if (value === undefined) return undefined;

  return isNaN(Number(value)) ? "Must be a number" : undefined;
};

const email = value => {
  let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  return value.match(mailformat) ? undefined : "Not a Valid Email Addres";
};

const max4 = value => {
  if (value === undefined) return undefined;

  return value.length > 4 ? "Must be 4 characters or less" : undefined;
};

const requiredDropdown = value => {
  if (value === "validationError") {
    return "Required";
  } else if (value) {
    return undefined;
  } else {
    return "Required";
  }
};

const styles = () => ({});

class CC_contactDetails extends React.Component {
  state = {
    addrSame: false
  };

  componentDidMount() {
    this.props.scrollMeBar();
  }

  handleSameAddress = event => {
    this.setState({ addrSame: event.target.checked });

    if (event.target.checked) {
      store.dispatch(
        change(
          "client",
          "postalAddressOne",
          store.getState().form.client.values.resAddressOne
        )
      );
      store.dispatch(
        change(
          "client",
          "postalAddressTwo",
          store.getState().form.client.values.resAddressTwo
        )
      );
      store.dispatch(
        change(
          "client",
          "postalAddressThree",
          store.getState().form.client.values.resAddressThree
        )
      );
      store.dispatch(
        change(
          "client",
          "postalAddressFour",
          store.getState().form.client.values.resAddressFour
        )
      );
      store.dispatch(
        change(
          "client",
          "postalAddressCode",
          store.getState().form.client.values.postalCode
        )
      );
    }
  };

  render() {
    const validate = [];
    validate.push(required);

    let postalAddr = null;

    if (!this.state.addrSame) {
      postalAddr = (
        <React.Fragment>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                name={"postalAddressOne"}
                component={FormInput}
                label={"Postal Address 1"}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                name={"postalAddressTwo"}
                component={FormInput}
                label={"Postal address 2"}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                name={"postalAddressThree"}
                component={FormInput}
                label={"Postal address 3"}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                name={"postalAddressFour"}
                component={FormInput}
                label={"Postal address 4"}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                name={"postalAddressCode"}
                component={FormInput}
                label={"Postal Address Code"}
                validate={[number, max4]}
                checkValidation={this.props.checkValidation}
              />
            </FormControl>
          </Grid>
        </React.Fragment>
      );
    }

    return (
      <div className="contentWithStepper">
        <Card>
          <CardHeader title="Client Contact Details" />
          <CardContent>
            <Grid container spacing={24}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    component={FormInput}
                    isrequired={false}
                    validate={[...validate, number]}
                    checkValidation={this.props.checkValidation}
                    name="cellNumber"
                    label="Cell number *"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    component={FormInput}
                    isrequired={true}
                    validate={[...validate, email]}
                    checkValidation={this.props.checkValidation}
                    name="email"
                    label="Email *"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"telNumberHome"}
                    component={FormInput}
                    label={"Tel (h)"}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"telNumberWork"}
                    component={FormInput}
                    label={"Tel (w)"}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"resAddressOne"}
                    component={FormInput}
                    label={"Residential address 1"}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"resAddressTwo"}
                    component={FormInput}
                    label={"Residential address 2"}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"resAddressThree"}
                    component={FormInput}
                    label={"Residential address 3"}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"resAddressFour"}
                    component={FormInput}
                    label={"Residential address 4"}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Field
                    name={"postalCode"}
                    component={FormInput}
                    validate={[number, max4]}
                    checkValidation={this.props.checkValidation}
                    label={"Residential Address Code"}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6} style={{ display: "flex" }}>
                <Typography
                  variant="body2"
                  style={{
                    height: "fit-content",
                    position: "relative",
                    top: "24%"
                  }}
                >
                  Postal Address same as Residential Address?
                </Typography>
                <Checkbox
                  checked={this.state.addrSame}
                  onChange={this.handleSameAddress}
                  value="brokerUser"
                />
              </Grid>
              {postalAddr}
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(CC_contactDetails);



// WEBPACK FOOTER //
// ./src/views/Clients/components/CC_contactDetails.jsx